import React, { useEffect, useState } from "react";

import moment, { Moment } from "moment";

export const TimerWithSuffix = ({
  date,
  suffix: { mins, secs, hours },
}: {
  date: Moment;
  suffix: {
    mins: string;
    secs: string;
    hours: string;
  };
}) => {
  const [currentTime, setCurrentTime] = useState(moment());
  const timeBetween = moment.duration(date.diff(currentTime));

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(moment());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <p>
      {timeBetween.hours() > 0 && (
        <span>
          {timeBetween.hours()}
          {hours}{" "}
        </span>
      )}
      {timeBetween.minutes() > 0 && (
        <span>
          {timeBetween.minutes()}
          {mins}{" "}
        </span>
      )}
      {timeBetween.seconds() > 0 && (
        <span>
          {timeBetween.seconds()}
          {secs}{" "}
        </span>
      )}
    </p>
  );
};

TimerWithSuffix.defaultProps = {
  date: moment(),
  suffix: {
    mins: "m",
    secs: "s",
    hours: "h",
  },
};
